// 支付相关接口
export default {
  QUESTIONNAIRE_DETAIL: '/api/v3/contest/questionnaire/detail',                              // 获取问卷内容(学生端)

  QUESTIONNAIRE_SUBMIT: '/api/v3/contest/questionnaire/submit'                              // 提交问卷(学生端)
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/questionnaireV3.js